import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/app/templates/$id')({
  component: () => <Outlet />,
});
